import { render } from "./PermissionsBaseView.vue?vue&type=template&id=d6f8d920&ts=true"
import script from "./PermissionsBaseView.vue?vue&type=script&lang=ts"
export * from "./PermissionsBaseView.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__